import { useState, useEffect } from "react";
import axios from "axios";

export const useShortURL = (click_url) => {
    const [shortURL, setShortURL] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            const url =  `${site['site_url']}/ajax/pyk.core.php?action=add.shortURL`;

            try {
                const response = await axios({
                    url: url,
                    method: "POST",
                    data: {
                        url: click_url,
                    },
                    withCredentials: false,
                    headers: { 
                        "Content-Type": "multipart/form-data" 
                    },
                });

                if (response.data.status === 'success') {
                    setShortURL(response.data.data.shorturl);
                } else {
                    setError('No data available.');
                }

            } catch (error) {
                setError('Failed to load data. Please try again later.');
            }
            
            setLoading(false);
        }
        if (click_url) {
            fetchData();
        }
    
    },[click_url]);

    return { shortURL, error, loading };
}

export const useReferral = () => {
    const [referral, setReferral] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            const url =  `${site['site_url']}/ajax/tsw.core.php?action=referral.stats`;
            try {
                const response = await axios({
                    url: url,
                    method: "POST",
                    data: {},
                    withCredentials: true,
                    headers: { 
                        "Content-Type": "multipart/form-data" 
                    },
                });
                if (response.data.status === 'success') {
                    setReferral(response.data.data);
                } else {
                    setError('No data available.');
                }
            } catch (error) {
                setError('Failed to load data. Please try again later.');
            }
            setLoading(false);
        }
        fetchData();
    },[]);

    return { referral, error, loading };
}

export const sendReferralInvite = async (email) => {
    const url = `${site['site_url']}/ajax/tsw.core.php?action=referral.invite`;
    try {
        const response = await axios({
            url: url,
            method: "POST",
            data: { email: email },
            withCredentials: true,
            headers: { 
                "Content-Type": "multipart/form-data" 
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error sending invite:', error);
        throw new Error('An error occurred. Please try again.');
    }
}